import { type ReactNode } from 'react'

type OptionalValueTdProps<Value extends number | string | Date> = {
    children?: Value | undefined | null
    format: (value: Value) => ReactNode
}
const OptionalValueCell = <Value extends number | string | Date>({
    children,
    format,
}: OptionalValueTdProps<Value>) => (
    <>
        {children === undefined || children === null ? (
            <div className="long-dash">
                <hr />
            </div>
        ) : (
            format(children)
        )}
    </>
)

export const optionalValueCellFactory =
    <Value extends number | string | Date>(
        format: OptionalValueTdProps<Value>['format']
    ) =>
    (props: Omit<OptionalValueTdProps<Value>, 'format'>) => (
        <OptionalValueCell {...props} format={format} />
    )
